export class TipoAtendimentoCirastCmd {
  nome: string = '';
  valor: number = 0;
}
